/*
 * Adds delay to allow for ble transaction completion
 * Revisit if still needed when ordered async calls work is done
 */
export const delayDab = (onPress: () => void) => {
  setTimeout(() => {
    onPress();
  }, 125);
};
